export const ACCESS_TOKEN_KEY = '__ACCESS_TOKEN';
export const REFRESH_TOKEN_KEY = '__REFRESH_TOKEN';

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

export const getAccessToken = (): string | null => {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
  return window.localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setTokens = ({ accessToken, refreshToken }: AuthTokens): void => {
  window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const clearTokens = (): void => {
  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const hasTokens = (): boolean => Boolean(getAccessToken() && getRefreshToken());
